import React from 'react';
import {
  buroPersonaF,
  buroPersonaFE,
  buroPersonaM,
} from "../../../../../../Assets/Images";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { selectedPersonCSS } from './SelectedPerson.css';

const persons = [
  {
    img: buroPersonaFE,
    type: 1,
    title: 'Soy Persona Física con Actividad Empresarial.',
    description: 'Soy independiente o empresario con ingresos facturados a mi nombre.',
    fields: ['firstName', 'paternal', 'maternal', 'rfc', 'ciec', 'phone', 'email', 'confirmEmail'],
    placeholders: ['Primer nombre', 'Apellido paterno', 'Apellido materno', 'RFC con homoclave', 'Clave Ciec', 'Telefono', 'Correo electrónico', 'Confirma correo electrónico'],
    disabled: false
  },
  {
    img: buroPersonaF,
    type: 3,
    title: 'Soy Persona Física',
    description: 'Mis ingresos mayormente son por nómina o pensión.',
    fields: ['firstName', 'paternal', 'maternal', 'rfc', 'phone', 'email', 'confirmEmail'],
    placeholders: ['Primer nombre', 'Apellido paterno', 'Apellido materno', 'RFC con homoclave', 'Telefono', 'Correo electrónico', 'Confirma correo electrónico'],
    disabled: false
  },
  {
    img: buroPersonaM,
    type: 2,
    title: 'Soy persona Moral.',
    description: 'Mis ingresos mayormente son porque emito facturas.',
    fields: ['isMoralPersonName', 'isMoralPersonRfc', 'isMoralPersonCiec', 'isMoralPersonEmail', 'isMoralPersonConfirmEmail'],
    placeholders: ['Nombre del representante', 'RFC con homoclave', 'Clave Ciec', 'Telefono', 'Correo electrónico', 'Confirma correo electrónico'],
    disabled: false
  }
];

export const SelectedPerson = ({ pageStep3, setPageStep3, reset }) => {

  const [hoveredIndex, setHoveredIndex] = React.useState(null);


  const handleSelect = (type) => {
    // Resetear todo el formulario
    reset({}, {
      keepValues: false,
      keepDefaultValues: true,
      keepErrors: false,
      keepDirty: false,
      keepIsSubmitted: false,
      keepTouched: false,
      keepIsValid: false,
      keepSubmitCount: false
    });

    // Actualizar el tipo de persona
    setPageStep3((prev) => ({
      ...prev,
      selectedTypePerson: type,
      fields: persons.find((person) => person.type === type).fields,
      placeholders: persons.find((person) => person.type === type).placeholders,
    }));
  };

  return (
    <div css={selectedPersonCSS} className="InfoContainer  grid-cols-2 gap-4 items-start py-4">
      <TransitionGroup component={null}>
        {persons.map((person, index) => {
          const isSelected = pageStep3.selectedTypePerson === person.type;
          const isHovered = hoveredIndex === index;

          return (
            <CSSTransition
              key={person.type}
              timeout={300}
              classNames="person-transition"
            >
              <div
                className={`flex flex-col items-center transition-all duration-300 rounded-xl p-2 person-transition-item ${person.disabled ? "opacity-50 cursor-not-allowed border-gray-300" : "cursor-pointer"
                  }`}
                style={{
                  width: "100%",
                  maxWidth: "min-content",
                  display: "flex",
                  flexDirection: "column",
                  border: isSelected ? "2px solid #1FDD8F" : "2px solid #E5E5E5",
                  borderRadius: "15px",
                  margin: "0 auto",
                  transform: isHovered && !isSelected && !person.disabled ? "scale(1.05)" : "scale(1)",
                  boxShadow: isHovered && !person.disabled ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none",
                }}
                onClick={() => !person.disabled && handleSelect(person.type)}
                onMouseEnter={() => !person.disabled && setHoveredIndex(index)}
                onMouseLeave={() => !person.disabled && setHoveredIndex(null)}
              >
                <img
                  src={person.img}
                  className="PersonImg"
                  style={{
                    display: "block",
                    width: person.type === 2 ? "90px" : person.type === 3 ? "60px" : "70px",
                    height: person.type === 2 ? "70px" : person.type === 3 ? "60px" : "70px",
                    margin: "0 auto",
                    filter: person.disabled ? "grayscale(100%)" : "none",
                  }}
                />
                <div className={`GreenTextContainer text-center mt-2 ${person.disabled ? "text-gray-400" : ""}`}>
                  {person.title}
                </div>
                <div className={`BlackTextContainer text-center mt-1 ${person.disabled ? "text-gray-500" : ""}`}>
                  {person.description}
                </div>
              </div>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </div>
  )
}
